import React from 'react';
import './WhoWeAre.scss';

const WhoWeAre: React.FC = () => {
  return (
    <section className="about" id="who-we-are">
      <span className="about__label">Sobre nosotros</span>
      <h2 className="about__title">Diseñado para la realidad<br />de la gastronomía</h2>
      <p className="about__description">
        <span>Tecnología simple para una gestión gastronómica eficiente.</span>
      </p>
      <p className="about__description">
        Somos una plataforma creada para restaurantes, cafeterías y locales de comida que buscan
        digitalizar sus operaciones. Con MedioPunto manejas ventas, inventario, personal y más
        desde un sistema ágil, moderno y adaptado a tu ritmo de trabajo.
      </p>
    </section>
  );
};

export default WhoWeAre;
